import { DiToken, registerDiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { BcfAppId } from './types';

// biome-ignore lint/style/useNamingConvention: must be that way
export const BCF_APP_ID: DiToken<BcfAppId> = new DiToken<BcfAppId>('bcfAppId');

// biome-ignore lint/style/useNamingConvention: must be that way
export const APP_SERVER_COUNTRY_IP: DiToken<string> = new DiToken<string>('appServerCountryIp');

// biome-ignore lint/style/useNamingConvention: must be that way
export const WORKER_SIDE_MESSANGER_IS_VIRTUAL: DiToken<boolean> = new DiToken<boolean>('workerSideMessangerIsVirtual');

// biome-ignore lint/style/useNamingConvention: must be that way
export const WORKER_SIDE_MESSANGER_IS_VIRTUAL_DEFAULT_VALUE: boolean = false;

export function registerBcfAppId(bcfAppId: BcfAppId): void {
  registerDiToken(BCF_APP_ID, () => bcfAppId);
}
